import PropTypes from "prop-types";
import React, { useState } from "react";
import { useStyles } from "../Enrollments/styles";
import { confirmationError, confirmationSuccess } from "../../styles/common.css";
import Snackbar from "../Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import { ClipLoader } from "react-spinners";
import SearchEnrollments from "./Enrollments";

const Enrollments = (props) => {
  const classes = useStyles();
  const {
    enrollments,
    fetchEnrollments,
    fetchMoreEnrollments,
    fetchAddNote,
    fetchCancelEnrollments,
    resubmitEnrollment,
    fetchUpdateEnrollmentName,
    fetchSendVerification,
    closeSnackbar,
    showSnackBar,
    successMessage,
    errorMessage,
    isProcessing,
    adminUser,
    page,
    limit,
    hasNext,
    total,
  } = props;

  return (
    <div className={classes.root}>
      <Snackbar
        id="message-id"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={showSnackBar}
        onClose={closeSnackbar}
        className={successMessage ? confirmationSuccess : confirmationError}
        message={successMessage || errorMessage}
      />
      <Backdrop className={classes.backdrop} open={isProcessing}>
        <ClipLoader sizeUnit="px" size={100} color="#ED0874" loading />
      </Backdrop>
      <SearchEnrollments
        adminUser={adminUser}
        enrollments={enrollments}
        fetchAddNote={fetchAddNote}
        fetchEnrollments={fetchEnrollments}
        fetchMoreEnrollments={fetchMoreEnrollments}
        fetchCancelEnrollments={fetchCancelEnrollments}
        resubmitEnrollment={resubmitEnrollment}
        fetchUpdateEnrollmentName={fetchUpdateEnrollmentName}
        fetchSendVerification={fetchSendVerification}
        memberID={props.params.memberId}
        page={page}
        limit={limit}
        hasNext={hasNext}
        total={total}
      />
      <Backdrop className={classes.backdrop} open={isProcessing}>
        <ClipLoader sizeUnit="px" size={100} color="#ED0874" loading />
      </Backdrop>
    </div>
  );
};

PropTypes.Enrollments = {
  enrollments: PropTypes.array,
  fetchEnrollments: PropTypes.func,
  fetchMoreEnrollments: PropTypes.func,
  fetchAddNote: PropTypes.func,
  fetchCancelEnrollments: PropTypes.func,
  resubmitEnrollment: PropTypes.func,
  fetchUpdateEnrollmentName: PropTypes.func,
  fetchSendVerification: PropTypes.func,
  closeSnackbar: PropTypes.func,
  showSnackBar: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  isProcessing: PropTypes.bool,
  adminUser: PropTypes.object,
  page: PropTypes.number,
  limit: PropTypes.number,
  hasNext: PropTypes.bool,
  total: PropTypes.number,
};

export default Enrollments;
